import React from 'react';
import ROUTER_URLS from '../../../utils/router/urls';
import Header from '../../../compounds/Common/Header';
import Dashboard from '../../../compounds/Dashboard/Dashboard';
import EliasStatsFilter from '../../../compounds/EliasStatsFilter/EliasStatsFilter';
import { PAGE_SUBTITLE, PAGE_TITLE, statsFilters } from './constants';
import PlayerGameGroupBy from '../../../compounds/PlayerGameGroupBy/PlayerGameGroupBy';
import API_URLS from '../../../../api/api_urls';
import { advancedModalFilterCategories, gameModalFilterCategories } from '../constants';
import ModalFilters from '../../../compounds/ModalFilters/ModalFilters';
import { ContextFilterType } from '../../../types/context';
import NbaPlayerFiltersLayout from '../../../compounds/nba/NbaPlayerFiltersLayout';
import withCopyableUrl, { WithCopyableUrlProps } from '../../../compounds/CopyableUrlWrapper/CopyableUrlWrapper';
import FinderStackLayout from '../../../compounds/FinderStackLayout/FinderStackLayout';
import { appendContextFilters } from '../../../utils/nba/search';

interface IProps extends WithCopyableUrlProps {};

function PlayerGameFinderSearch({ handleDone }: IProps) {

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const pageSpecificSearchEnabled = (_context: ContextFilterType): boolean => true;

  const statsFilterPartial = <EliasStatsFilter statsFilterOptions={statsFilters} displayYearInfo />;

  const groupByPartial = <PlayerGameGroupBy />

  const topModalPartial = (
    <ModalFilters
      buttonTitle='Game Type & Date Filters'
      filters={gameModalFilterCategories}
      filterType='gameTypeFilters'
    />
  );

  const bottomModalPartial = (
    <ModalFilters
      buttonTitle='Advanced Filters'
      filters={advancedModalFilterCategories}
      filterType='advancedFilters'
    />
  );

  return (
    <Dashboard>
      <FinderStackLayout
        header={<Header title={PAGE_TITLE} subtitle={PAGE_SUBTITLE} />}
        topPanel={
          <NbaPlayerFiltersLayout
            handleDone={handleDone}
            statsFilterPartial={statsFilterPartial}
            pageSpecificSearchEnabled={pageSpecificSearchEnabled}
            groupByPartial={groupByPartial}
            apiUrls={API_URLS.nba}
            topModalPartial={topModalPartial}
            bottomModalPartial={bottomModalPartial}
            showHalfQuarter
          />
        }
      />
    </Dashboard>
  );
}

export default withCopyableUrl(
  PlayerGameFinderSearch,
  ROUTER_URLS.nba.playerGameFinderResults,
  statsFilters,
  appendContextFilters,
);
